export const locale = {
  lang: "it",
  data: {
    CANDIDATES_SOURCES: "Fonti candidati",
    CANDIDATES_SOURCE: "Fonte candidati",
    CANDIDATE_SOURCE: "Fonte candidato",
    REQUEST_OPENED: "Richieste aperte",
    REQUEST_CLOSED: "Richieste chiuse",
    MENU: {
      RATING_CANDIDATE: "Giudizi candidati",
    },
    ALERT: {
      SUCCESS_CREATE_RATING: "Giudizio creato con successo.",
      ERROR_CREATE_RATING: "Errore nella creazione del giudizio.",
      SUCCESS_EDIT_RATING: "Giudizio modificato con successo.",
      ERROR_EDIT_RATING: "Errore nella modifica del giudizio.",
      ERROR_DELETE_RATING: "Errore nell' eliminazione del giudizio.",
      SELECT_NAME_OR_COLOR: "Inserisci nome e colore",
    },
    BARGAINING_INSERT_DATE: "Data contrattazione",
    FROM_START_DATE: "Da data inizio",
    TO_START_DATE: "A data inizio",
    FROM_BARGAINING_DATE: "Da (contrattazione)",
    TO_BARGAINING_DATE: "A (contrattazione)"
  },
};
